// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"f2e2e23c","205":"f2e2e23c","394":"9275dcf2"}[chunkId] + ".chunk.css";
};